import React from "react"
import { Link } from "react-router-dom"
import Config from "config"

import {
  Button,
  Container,
  Row,
  Col,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
} from "reactstrap"

import { withRouter } from "react-router-dom"

const enterYourZipCode = "Enter Your Zip Code"

class IndexHeader extends React.Component {
  constructor(props) {
    super(props)
    this.regex = /^\d{5}$/
    this.state = {
      zipCode: "",
      placeholder: enterYourZipCode,
      showError: false,
    }
    this.handleChange = this.handleChange.bind(this)
    this._handleLocation = this._handleLocation.bind(this)
    this._getPosition = this._getPosition.bind(this)
    this._errorCallback = this._errorCallback.bind(this)
  }

  componentDidMount() {
    
  }

  _handleLocation() {
    if (navigator.geolocation) {
      console.log("Navigator Available - Setting Zip Code")
      navigator.geolocation.getCurrentPosition(
        this._getPosition,
        this._errorCallback,
        { timeout: 10 * 1000 }
      )
    } else {
      console.log("Navigator NOT Available - Not Setting Zip Code")
    }
    // navigator.permissions.query({name:'geolocation'})
    // console.log('Hello World');
  }

  _errorCallback(err) {
    if (err) {
      console.log(err)
    }
  }

  _getPosition(position) {
    console.log("Fetch-ZipCode-Debug-1")
    if (position && position.coords) {
      console.log("Fetch-ZipCode-Debug-2")
      this.setState({
        placeholder: "Fetching Your ZipCode...",
      })
      const { latitude, longitude } = position.coords
      if (latitude && longitude) {
        console.log("Fetch-ZipCode-Debug-3")
        // console.log(latitude, longitude);
        fetch(
          `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${Config.GoogleGeolocation}`
        )
          .then((res) => res.json())
          .then((result) => {
            // console.log(result.results.length);
            // console.log(JSON.stringify(result, null, 4));
            console.log("Fetch-ZipCode-Debug-4")
            if (result && result.results && result.results.length > 0) {
              console.log("Fetch-ZipCode-Debug-5")
              const { results } = result
              const resultWithZipCode = results.find((v1) => {
                return (
                  v1.address_components &&
                  v1.address_components.length &&
                  v1.address_components.find((v2) =>
                    v2.types.includes("postal_code")
                  )
                )
              })
              // console.log(resultWithZipCode);
              if (resultWithZipCode) {
                console.log("Fetch-ZipCode-Debug-6")
                const zipCodeObj = resultWithZipCode.address_components.find(
                  (v) => v.types.includes("postal_code")
                )
                // console.log(zipCodeObj);
                if (zipCodeObj) {
                  console.log("Fetch-ZipCode-Debug-7")
                  console.log(zipCodeObj.long_name)
                  this.setState({
                    zipCode: zipCodeObj.long_name.slice(0, 5) || "",
                    placeholder: enterYourZipCode,
                  })
                }
              }
            }

            // ===============
            // ===== DEV =====
            // ===============
            // result.results.forEach(item => {
            //   const postalCodeObj = item.address_components.find(v => v.types.includes('postal_code'));
            //   if (postalCodeObj) {
            //     console.log(postalCodeObj.long_name);
            //   }
            // })
          })
          .catch((err) => {
            console.log(`Error Fetching GeoCode.Error:${err}`)
          })
      }
    }
  }

  handleChange(e) {
    e.preventDefault()
    let name = e.target.name
    let value = e.target.value
    this.setState({
      [name]: value.slice(0, 5),
    })
  }

  _isZipCodeValid() {
    return this.regex.test(this.state.zipCode)
  }

  render() {
    const zipCode = this.state.zipCode
    return (
      <>
        <div className="header bg-chift pt-6 pb-7 flex-wrapper">
          <Container>
            <div className="header-body">
              <Row className="align-items-center">
                <Col lg="12">
                  <div>
                    <h4
                      className="display-3 text-white mb-0 text-center welcomeTxt"
                      style={{ fontWeight: 100 }}
                    >
                      car washes that come to you
                    </h4>
                    <Container className="chift-container-sm">
                      <div className="mt-5 text-center input-group-merge">
                        <Form
                          className="needs-validation zipCode-form"
                          noValidate
                        >
                          <InputGroup className="mb-3 input-group-alternative">
                            
                            <Input
                              value={this.state.zipCode}
                              name="zipCode"
                              onChange={(e) => this.handleChange(e, "zipCode")}
                              placeholder={this.state.placeholder}
                              type="text"
                              pattern="\d*"
                              autoComplete="off"
                            />
                            <InputGroupAddon addonType="append">
                                <Button type="button" color="white" onClick={ this._handleLocation } style={{ height: "100%", fontSize: '12px' }} >Detect Location</Button>
                            </InputGroupAddon>
                            <InputGroupAddon addonType="append">
                              {zipCode ? (
                                <Link
                                  to={{
                                    pathname: `/merchants/${this.state.zipCode}`,
                                    state: {
                                      zipCode,
                                    },
                                  }}
                                >
                                  <Button
                                    outline
                                    color="white"
                                    type="submit"
                                    disabled={!this._isZipCodeValid()}
                                    style={{ height: "100%" }}
                                  >
                                    <i className="fas fa-arrow-circle-right text-white"></i>
                                  </Button>
                                </Link>
                              ) : (
                                <Button
                                  outline
                                  color="white"
                                  type="submit"
                                  disabled={!this._isZipCodeValid()}
                                  style={{ height: "100%" }}
                                  onClick={(e) => e.preventDefault()}
                                >
                                  <i className="fas fa-arrow-circle-right text-white"></i>
                                </Button>
                              )}
                            </InputGroupAddon>
                          </InputGroup>
                        </Form>
                        {this.state.zipCode.length === 5 &&
                        !this._isZipCodeValid() ? (
                          <p
                            className="mt-n2"
                            style={{
                              color: "red",
                              fontWeight: "bold",
                              fontSize: "1.3rem",
                            }}
                          >
                            Please Enter A Valid Zip Code
                          </p>
                        ) : null}
                      </div>
                    </Container>
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </div>
      </>
    )
  }
}

export default withRouter(IndexHeader)
